import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import {
  MuiCheckboxWithLabel,
  MuiInput,
  MuiPasswordInput
} from '../../shared/form-element';
import { CreateDialogViewTemplate } from '../create-dialog-template/create-dialog-view-template';

const vt = viewTexts.dialogs.createNewUser;

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  username: string | undefined;
  usernameErrors: string[] | undefined;
  usernameOnInput: (v: string) => void;
  email: string | undefined;
  emailErrors: string[] | undefined;
  emailOnInput: (v: string) => void;
  password: string | undefined;
  passwordErrors: string[] | undefined;
  passwordOnInput: (v: string) => void;
  isActive: boolean;
  onActiveFlagChange: (b: boolean) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const CreateNewUserDialogView: FC<Props> = memo(
  ({
    open,
    onClose,
    username = '',
    usernameErrors = [],
    usernameOnInput,
    email = '',
    emailErrors = [],
    emailOnInput,
    password = '',
    passwordErrors = [],
    passwordOnInput,
    isActive,
    onActiveFlagChange,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => (
    <CreateDialogViewTemplate
      open={open}
      onClose={onClose}
      title={vt.title}
      descriptions={vt.descriptions}
      submitButtonEnabled={submitButtonEnabled}
      nonFieldErrors={nonFieldErrors}
    >
      <InputWrapper>
        <MuiInput
          label={vt.labels.userName}
          required={true}
          value={username}
          onInput={usernameOnInput}
          helperText={usernameErrors.join(' ')}
          error={usernameErrors.length > 0}
        />
      </InputWrapper>
      <InputWrapper>
        <MuiInput
          label={vt.labels.email}
          type='email'
          required={true}
          value={email}
          onInput={emailOnInput}
          helperText={emailErrors.join(' ')}
          error={emailErrors.length > 0}
        />
      </InputWrapper>
      <InputWrapper>
        <MuiPasswordInput
          label={vt.labels.password}
          required={true}
          value={password}
          onInput={passwordOnInput}
          helperText={passwordErrors.join(' ')}
          error={passwordErrors.length > 0}
        />
      </InputWrapper>
      <InputWrapper>
        <MuiCheckboxWithLabel
          label={vt.userIsActive}
          checked={isActive}
          onChange={onActiveFlagChange}
        />
      </InputWrapper>
    </CreateDialogViewTemplate>
  )
);

CreateNewUserDialogView.displayName = 'CreateNewUserDialogView';
